import React, { forwardRef } from 'react';
import { Grid, TextField, Box } from '@mui/material';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useListPropertyContext } from '../../../../../contexts/ListPropertyContext';
import ReusableTextField from '../../../../../components/ReusableTextField/ReusableTextField';
import { contactFormStyles } from '../../../../shared/ContactUsForm/ContactForm/ContactForm.styles';

const PhoneTextField = forwardRef((props, ref) => {
  const { value, onChange, ...other } = props;
  return (
    <TextField
      {...other}
      inputRef={ref}
      fullWidth
      label="Phone number"
      variant="outlined"
      value={value || ''}
      onChange={(e) => onChange && onChange(e.target.value)}
    />
  );
});

PhoneTextField.displayName = 'PhoneTextField';

const PersonalInfoSection = () => {
  const { formData, updateFormData } = useListPropertyContext();
  const styles = contactFormStyles(false);

  const handleFirstNameChange = (e) => {
    updateFormData('firstName', e.target.value);
  };

  const handleLastNameChange = (e) => {
    updateFormData('lastName', e.target.value);
  };

  const handleEmailChange = (e) => {
    updateFormData('email', e.target.value);
  };

  const handlePhoneChange = (value) => {
    updateFormData('phone', value || '');
  };

  const handleCountryChange = (countryCode) => {
    updateFormData('country', countryCode || 'AE');
  };

  return (
    <Grid container spacing={2}>
      {/* Row 1 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <ReusableTextField
          label="First name"
          value={formData.firstName || ''}
          onChange={handleFirstNameChange}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <ReusableTextField
          label="Last name"
          value={formData.lastName || ''}
          onChange={handleLastNameChange}
        />
      </Grid>
      {/* Row 2 */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <ReusableTextField
          label="Email"
          type="email"
          value={formData.email || ''}
          onChange={handleEmailChange}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Box sx={styles.phoneInputContainer}>
          <PhoneInput
            international
            country={formData.country || 'AE'}
            defaultCountry="AE"
            value={formData.phone || ''}
            onChange={handlePhoneChange}
            onCountryChange={handleCountryChange}
            inputComponent={PhoneTextField}
            countryCallingCodeEditable={false}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default PersonalInfoSection;

